/// <amd-module name="Release/SignalR/SignalRHubProxies" />
import { jqueryShimmed } from "VSS/Features/SignalR/3rdParty/jquery.shimmed";

import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";

import { EnvironmentStatus, DeploymentStatus, DeploymentOperationStatus, ReleaseTaskLogUpdatedEvent } from "Release/Client/Contracts/Release";

export interface IReleaseDetailHubServer {
    watchRelease: (projectId: string, releaseId: number) => Promise<void>;
    stopWatchingRelease: (projectId: string, releaseId: number) => Promise<void>;
    watchReleaseDefinitionReleases: (projectId: string, definitionId: number) => Promise<void>;
    stopWatchingReleaseDefinitionReleases: (projectId: string, definitionId: number) => Promise<void>;
    watchReleaseDefinitionsReleases: (projectId: string, definitionIds: number[]) => Promise<void>;
    stopWatchingReleaseDefinitionsReleases: (projectId: string, definitionIds: number[]) => Promise<void>;
}

export interface IReleaseDetailHubClient {
    onReleaseCreated?: (projectId: string, definitionId: number, releaseId: number) => void;
    onReleaseUpdated2?: (projectId: string, definitionId: number, releaseId: number) => void;
    onReleaseEnvironmentUpdated?: (projectId: any, definitionId: any, releaseId: any, environmentId: any) => void;
    onDeployJobStartedEvent?: (projectId: string, definitionId: number, releaseId: number, definitionEnvironmentId: number, releaseEnvironmentId: number) => void;
    onReleaseTasksUpdated?: (projectId: string, releaseId: number, environmentId: number, phaseId: string, stepId: number, jobTimelineRecordId: string, planId: string, timelineRecords: any /* SignalROperation */) => void;
    onReleaseTaskLogUpdated?: (notificationEvent: ReleaseTaskLogUpdatedEvent) => void;
    onPlanGroupsStarted?: (notificationEvent: any /* TaskOrchestrationPlanGroupsStartedEvent */) => void;
    onReleaseEnvironmentStatusUpdated?: (projectId: string, definitionId: number, releaseId: number, environmentId: number, environmentStatus: EnvironmentStatus, deploymentStatus: DeploymentStatus, deploymentOperationStatus: DeploymentOperationStatus) => void;
    onReleaseApprovalPending?: (projectId: string, definitionId: number, releaseId: number, releaseEnvironmentId: number, approvalId: number, approverId: string) => void;
}

export namespace HubNames {
    export const releaseHub = "releaseHub";
}

export function getReleaseProxyToRegister<C, S>(baseProxy: ISignalRHubProxy<any, any>): ISignalRHubProxy<C, S> {
    const $ = jqueryShimmed;
    baseProxy.server = {
        stopWatchingRelease: function (projectId: string, releaseId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["stopWatchingRelease"], $.makeArray(arguments)));
        },

        watchRelease: function (projectId: string, releaseId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["WatchRelease"], $.makeArray(arguments)));
        },

        watchReleaseDefinitionReleases: function (projectId: string, definitionId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["WatchReleaseDefinitionReleases"], $.makeArray(arguments)));
        },

        stopWatchingReleaseDefinitionReleases: function (projectId: string, definitionId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["StopWatchingReleaseDefinitionReleases"], $.makeArray(arguments)));
        },

        watchReleaseDefinitionsReleases: function (projectId: string, definitionIds: number[]) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["WatchReleaseDefinitionsReleases"], $.makeArray(arguments)));
        },

        stopWatchingReleaseDefinitionsReleases: function (projectId: string, definitionIds: number[]) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["StopWatchingReleaseDefinitionsReleases"], $.makeArray(arguments)));
        }
    };

    return baseProxy;
}